<template>
    <div class="work-order-info">
        <div class="work-order-info-content">
            {{ detailInfo.complaintDesc }}
        </div>
        <div class="work-order-info-imgs" v-if="detailInfo.complaintAttachment">
            <div class="image-wrapper" v-for="(item, index) in srcList" :key="index">
                <el-image :ref="'previewImage' + index" class="preview-image" style="width: 30px; height: 30px" fit="cover" :src="item" :preview-src-list="srcList" :initial-index="index">
                    <template #error>
                        <div class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                    </template>
                </el-image>
                <div class="image-mask" @click="handlePreview(index)">
                    <span>预览</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WorkOrderInfo',
    props: {
        detailInfo: {
            type: Object,
            default: () => {  }
        }
    },
    computed: {
        srcList() {
            return (this.detailInfo.complaintAttachment).split(',').map(item => {
                return this.mixinQiniuImg(item)
            })
        }
    },
    methods: {
        handlePreview(index) {
            const image = this.$refs['previewImage' + index];
            if (image && image[0]) {
                image[0].showViewer = true;
            }
        }
    },
    data() {
        return {
            
        }
    }
}
</script>

<style lang="less" scoped>
.work-order-info {

    &-content {
        white-space: pre-wrap;
    }

    &-imgs {
        padding-top: 20px;
        background: #FAFAFA;
        display: flex;
        flex-wrap: wrap;
        gap: 12px;

        .image-wrapper {
            position: relative;
            cursor: pointer;

            .preview-image {
                position: relative;
                z-index: 1;
            }

            .image-mask {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.6);
                display: flex;
                justify-content: center;
                align-items: center;
                opacity: 0;
                transition: all 0.3s;
                z-index: 2;
                
                span {
                    color: #fff;
                    font-size: 14px;
                }
            }

            &:hover {
                .image-mask {
                    opacity: 1;
                }
            }
        }
    }
}
</style>